import styled from "styled-components";
import { Plus, CaretLeft, FileText } from "phosphor-react";
import DocumentForm from "./customer-forms/form/DocumentForm";
import { AnimatePresence } from "framer-motion";
import { useFirestore } from "react-redux-firebase";
import moment from "moment";
import { v4 } from "uuid";
import { newForm } from "./constants";

import useFirestoreCollection from "../../../hooks/useFirestoreCollection";

const Container = styled.div`
  * {
    transition: all 0.1s ease;
  }
  width: 100%;
  margin-top: 10px;
`;

const Item = styled.div`
  font-weight: 900;
  color: white;
  border: 1px solid ${({ c }) => c};
  border-radius: 3px;
  padding: 10px;
  margin: 10px 0;
  font-size: 16px;
  background: ${({ c }) => c};
  display: flex;
  align-items: center;
  justify-content: space-between;

  input {
    border: 1px solid transparent;
    margin-left: 10px;
    color: white;
    background: transparent;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 900;
    width: 100%;
    &:focus {
      border-radius: 0px !important;
      outline: none;
      border: 1px solid white;
      padding-left: 5px;
    }
  }

  box-shadow: 5px 5px 47px -21px rgba(0, 0, 0, 0.8);
`;

const ItemTitle = styled.div`
  display: flex;
  align-items: center;
  width: 55%;
`;

const Arrow = styled.div`
  display: flex;
  justify-content: flex-end;
  svg {
    transition: all 0.3s ease;
    transform: ${({ open }) => (open ? "rotate(-90deg)" : null)};
    cursor: pointer;
  }
`;

const Create = styled.div`
  svg {
    margin-right: 5px;
  }
  font-weight: bold;
  color: ${({ c }) => c};
  border: 1px solid ${({ c }) => c};
  border-radius: 3px;
  padding: 7px;
  margin: 5px 5px;
  font-size: 12px;
  display: flex;
  align-items: center;
  background: transparent;
  &:hover {
    opacity: 1;
  }
  &:active {
    box-shadow: ${({ c }) => c} 0px 0px 0 0;
    transform: translate(2px, 2px);
  }
  cursor: pointer;
  box-shadow: ${({ c }) => c} 2px 2px 0 0;
  opacity: 0.5;
`;

const Buttons = styled.div`
  display: none;
  @media screen and (min-width: 900px) {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
  }
`;

const FormsList = ({
  contact,
  storedDocuments,
  setStoredDocuments,
  colors,
  previousItems,
}) => {
  const firestore = useFirestore();
  const { docs: prices } = useFirestoreCollection("prices", { orderBy: null });

  const createDocument = (type) => {
    let newDocs = [...storedDocuments];
    const newDoc = {
      id: v4(),
      contactID: contact.id,
      createDate: Date.now(),
      kits: newForm,
      type: type,
      title: type,
      open: false,
      depositDue: moment().add(90, "days").calendar(),
      fiftyDue: moment().add(120, "days").calendar(),
      fullDue: moment().add(150, "days").calendar(),
      productionDate: moment().add(180, "days").calendar(),
      shipDate: moment().add(200, "days").calendar(),
    };
    newDocs.push(newDoc);
    setStoredDocuments(newDocs);

    return firestore.collection("client-documents").doc(newDoc.id).set(newDoc);
  };
  const duplicateDocument = (doc) => {
    let newDocs = [...storedDocuments];
    const newDoc = {
      id: v4(),
      contactID: contact.id,
      createDate: Date.now(),
      kits: doc.kits,
      type: "final invoice",
      title: "final invoice",
      open: false,
      depositDue: doc.depositDue,
      fiftyDue: doc.fiftyDue,
      fullDue: doc.fullDue,
      productionDate: doc.productionDate,
      shipDate: doc.shipDate,
      notes: typeof doc.notes !== "undefined" ? doc.notes : "",
      psa: typeof doc.psa !== "undefined" ? doc.psa : "",
      tax: typeof doc.tax !== "undefined" ? doc.tax : "",
    };
    newDocs.push(newDoc);
    setStoredDocuments(newDocs);

    return firestore.collection("client-documents").doc(newDoc.id).set(newDoc);
  };

  const editDocument = (doc, key, value) => {
    console.log(doc.id);
    let docs = [...storedDocuments];
    docs[docs.indexOf(doc)][key] = value;
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const addKit = (doc) => {
    let docs = [...storedDocuments];
    const newKit = {
      id: v4(),
      createDate: Date.now(),
      items: [],
    };
    docs[docs.indexOf(doc)].kits.push(newKit);
    setStoredDocuments(docs);
    return firestore.update(
      { collection: "client-documents", doc: doc.id },
      docs[docs.indexOf(doc)]
    );
  };

  const convertDocument = () => {
    let newDocs = [...storedDocuments];
    const newDoc = {
      id: v4(),
      contactID: contact.id,
      createDate: Date.now(),
      kits: previousItems,
      type: "custom",
      title: "previous document",
      open: false,
      depositDue:
        typeof contact.despositDue !== "undefined" ? contact.despositDue : "",
      fiftyDue: typeof contact.fiftyDue !== "undefined" ? contact.fiftyDue : "",
      fullDue: typeof contact.fullDue !== "undefined" ? contact.fullDue : "",
      productionDate:
        typeof contact.productionDate !== "undefined"
          ? contact.productionDate
          : "",
      shipDate: typeof contact.shipDate !== "undefined" ? contact.shipDate : "",
      notes: typeof contact.notes !== "undefined" ? contact.notes : "",
      psa: typeof contact.psa !== "undefined" ? contact.psa : "",
      tax: typeof contact.tax !== "undefined" ? contact.tax : "",
    };
    newDocs.push(newDoc);
    setStoredDocuments(newDocs);

    return firestore.collection("client-documents").doc(newDoc.id).set(newDoc);
  };

  return (
    <Container>
      <Buttons>
        <Create
          c={colors["purchase agreement"]}
          onClick={() => createDocument("purchase agreement")}
        >
          <Plus size={15} />
          Purchase Agreement
        </Create>
        {previousItems.length ? (
          <Create onClick={() => convertDocument()}>
            Convert Previous Document
          </Create>
        ) : null}
      </Buttons>
      {storedDocuments.map((doc, i) => (
        <div key={i}>
          <Item c={colors[doc.type]} title={doc.title}>
            <ItemTitle>
              <FileText size={25} weight="fill" />
              <input
                key={doc.title}
                defaultValue={doc.title ? doc.title : doc.type}
                onBlur={(e) => editDocument(doc, "title", e.target.value)}
              />
            </ItemTitle>
            {doc.type === "purchase agreement" && (
              <Create onClick={() => duplicateDocument(doc)}>
                Convert to Final Invoice
              </Create>
            )}
            <Arrow open={doc.open}>
              <CaretLeft
                size={32}
                weight="fill"
                onClick={() => editDocument(doc, "open", !doc.open)}
              />
            </Arrow>
          </Item>

          <AnimatePresence>
            {doc.open && (
              <DocumentForm
                setStoredDocuments={setStoredDocuments}
                storedDocuments={storedDocuments}
                contact={contact}
                doc={doc}
                editDocument={editDocument}
                addKit={addKit}
                color={colors[doc.type]}
                prices={prices}
              />
            )}
          </AnimatePresence>
        </div>
      ))}
    </Container>
  );
};

export default FormsList;
